<template>
  <label class="flex-column form-row select-wrapper">
    <span class="block label-text" v-if="labelText">{{labelText}}</span>
    <span class="select-container relative block">
      <select class="rounded pointer" v-model="modeled" :name="name" :disabled="disabled" :class="{validation: validation && !modelValue}">
        <option :value="null" disabled>{{dynamicEmptyOption ? dynamicEmptyOption : "選択"}}</option>
        <option :value="item" v-for="(item, idx) in options" :key="idx">{{item}}</option>
      </select>
      <i class="fas fa-chevron-down"></i>
    </span>
  </label>
</template>

<script>
import {ref, watch} from "vue";

export default {
  name: "SelectWrapper",
  props:{
    modelValue:String,
    labelText: String,
    options:Array,
    name:String,
    smallRow:Boolean,
    validation:Boolean,
    disabled: Boolean,
    dynamicEmptyOption:String,
  },
  setup(props, {emit}){

    const modeled = ref(props.modelValue)

    watch(() => props.modelValue, (val) => {
      modeled.value = val
    })
    watch(() => modeled.value, (val) => {
      emit("update:modelValue", val)
    })

    return {modeled}
  }
}
</script>

<style scoped>
.form-row {
  width: 48%;
}
.form-row > span.label-text {
  padding-left: 10px;
  font-size: .8rem;
  width: 100%;
  margin-bottom: 5px;
}
.form-row > .select-container > select {
  outline: 0;
  -moz-appearance:none; /* Firefox */
  -webkit-appearance:none; /* Safari and Chrome */
  appearance:none;
  padding-left: 14px;
  width: 100%;
  /* border: 2px solid #f5f6fa; */
  height: 40px;
  padding-right: 14px;
  border: 2px solid #c8c8c9;
}

.enrollmentDate .form-row > .select-container > select,
.weddingDate .form-row > .select-container > select {
  width: 94%;
}

.form-row > .select-container > i.fa-chevron-down {
  position: absolute;
  right: 14px;
  top: 50%;
  transform: translateY(-50%);
  font-size: .8rem;
  pointer-events: none;
}
.form-row > .select-container > select:focus {
  border-color: #797979;;
}
</style>
